import messages from './messages';
import { regexMap, Options, Message, maxFieldLength } from './constants';

const defaultOptions = {
    allowPOBox: false,
    allowLongUSZipCode: true,
    isZipCodeRequired: true,
    isPhoneRequired: true,
    isLabelRequired: false,
};

type ValidationResults = {
    isValid: boolean;
    message?: Message;
}[];

const rules = {
    firstName: (value: string): ValidationResults => {
        return [
            {
                isValid: !regexMap.specialCharacters.test(value),
                message: messages.specialCharactersShort,
            },
            {
                isValid: value.length <= maxFieldLength.FIRST_NAME,
                message: messages.firstNameMax,
            },
        ];
    },
    lastName: (value: string): ValidationResults => {
        return [
            {
                isValid: !regexMap.specialCharacters.test(value),
                message: messages.specialCharactersShort,
            },
            {
                isValid: value.length <= maxFieldLength.LAST_NAME,
                message: messages.lastNameMax,
            },
        ];
    },
    country: (value: string): ValidationResults => {
        return [
            {
                isValid: !regexMap.specialCharacters.test(value),
                message: messages.specialCharacters,
            },
        ];
    },
    line1: (value: string, options: Options): ValidationResults => {
        return [
            {
                isValid: !regexMap.specialCharactersAddress.test(value),
                message: messages.specialCharactersAddress,
            },
            {
                isValid: !regexMap[options.allowPOBox ? 'all' : 'poBox'].test(value),
                message: messages.poBox,
            },
        ];
    },
    line2: (value: string, options: Options): ValidationResults => {
        return [
            {
                isValid: !regexMap.specialCharactersAddress.test(value),
                message: messages.specialCharactersAddress,
            },
            {
                isValid: !regexMap[options.allowPOBox ? 'all' : 'poBox'].test(value),
                message: messages.poBox,
            },
        ];
    },
    city: (value: string): ValidationResults => {
        return [
            {
                isValid: !regexMap.specialCharacters.test(value),
                message: messages.specialCharactersShort,
            },
        ];
    },
    state: (value: string): ValidationResults => {
        return [
            {
                isValid: !regexMap.specialCharacters.test(value),
                message: messages.specialCharactersAddress,
            },
        ];
    },
    zipCode: (value: string, options: Options): ValidationResults => {
        let valToCheck: keyof typeof regexMap = 'globalZipCode';
        let messageVal: keyof typeof messages = 'globalZipCode';

        if (options.isCountryUS) {
            if (options.allowLongUSZipCode) {
                valToCheck = 'usZipCode';
                messageVal = 'usZipCodeShipping';
            } else {
                valToCheck = 'usZipCodeShort';
                messageVal = 'usZipCodeShort';
            }
        }

        return [
            {
                isValid: !regexMap[valToCheck].test(value),
                message: messages[messageVal],
            },
        ];
    },
    phoneNumber: (value: string, options: Options): ValidationResults => {
        let isValid = true;
        let message = undefined;

        if (options.isPhoneRequired) {
            isValid = regexMap.phoneNumber.test(value);
            message = messages.phoneNumber;
        }
        return [
            {
                isValid,
                message,
            },
        ];
    },
    label: (value: string, options: Options): ValidationResults => {
        let isValid = true;
        let message = undefined;

        if (options.isLabelRequired) {
            isValid = !!value;
            message = messages.label;
        }

        return [
            {
                isValid,
                message,
            },
        ];
    },
    company: (): ValidationResults => [],
};

export default {
    defaultOptions: defaultOptions,
    rules: rules,
};
